<template>
  <div>
    <CollectionView :endpoint="utilities.path('modules/punishments/players/@/kicks', playerId)" v-model:reload="reload" default-order="createdAt:desc">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("punishments.kicks") }}</h4>
          <ButtonKickPlayer v-if="authorization.moduleEnabled(modules.punishments) && authorization.permission('modules.punishments.kicks.create')" :community-id="communityId" :player-id="playerId" @kick="reload = true"/>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("reason") }}</div>
                <div class="table-header-cell">{{ translate("creator") }}</div>
                <div class="table-header-cell">{{ translate("createdAt") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    {{ item.reason }}
                  </div>
                  <div class="table-column">
                    <UserView :user="item.creator"/>
                  </div>
                  <div class="table-column">
                    {{ utilities.formatDatetime(item.createdAt) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
  </div>
</template>

<script setup>
import {CollectionView, utilities} from "@/niftybit";
import {ref, watch} from "vue";
import authorization from "@/authorization";
import UserView from "@/components/other/UserView.vue";
import ButtonKickPlayer from "@/systems/modules/punishments/kicks/ButtonKickPlayer.vue";
import {modules} from "@/systems/modules/modules";

const props = defineProps({
  communityId: String,
  playerId: String
});

const reload = ref(false);

watch(() => props.playerId, () => reload.value = true);

</script>